export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12215.e78f7257.jpg";